// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"fd47bb2e","782":"dc7e2062","787":"59b67441","881":"91a5fdab","922":"011f1958","944":"b3b8c6d4"}[chunkId] + ".chunk.js";
};